import React, { CSSProperties, ReactNode } from "react";
import './styles.css'

interface ModalProps {
    children?: string | ReactNode;
    onClose: () => void | undefined;
    style?: CSSProperties
}

export default function Modal(props: ModalProps) {

    return (
        <div className="modal_backdrop">
            <div className="modal_component_content" style={props.style}>
                <div className="action"
                    onClick={() => {
                        if (props?.onClose) {
                            props?.onClose()
                        }
                    }}>
                    <span>Close</span>
                </div>
                {props.children && props.children}
            </div>
        </div>
    )
}